import { animate, style, transition } from '@angular/animations';

export const maxHeightIf = (height: number) => {
  return [
    transition(':enter', [style({ 'max-height': 0 }), animate('.2s ease', style({ 'max-height': height + 'px' }))]),
    transition(':leave', [style({ 'max-height': height + 'px' }), animate('.2s ease', style({ 'max-height': 0 }))]),
  ];
};

export const maxHeightIfWithMarginTop = (height: number, marginTop: number, marginTopEmpty = 0) => {
  return [
    transition(':enter', [
      style({ 'max-height': 0, 'margin-top': marginTopEmpty }),
      animate('.2s ease', style({ 'max-height': height + 'px', 'margin-top': marginTop })),
    ]),
    transition(':leave', [
      style({ 'max-height': height + 'px', 'margin-top': marginTop }),
      animate('.2s ease', style({ 'max-height': 0, 'margin-top': marginTopEmpty })),
    ]),
  ];
};
